export default function Clients() {
  const clients = [
    { name: "Google", src: "/Google.png", height: "h-5 sm:h-10" },
    { name: "Abia State Government", src: "/Abia.png", height: "h-5 sm:h-10" },
    { name: "Ministry of Innovation, Science & Technology", src: "/Logo2.png", height: "h-6 sm:h-12" },
    { name: "Oilserv", src: "/Oil.png", height: "h-5 sm:h-10" },
    { name: "TEDx", src: "/image1.png", height: "h-5 sm:h-10" },
    { name: "Co-Creation Hub", src: "/image24.png", height: "h-5 sm:h-10" },
  ];

  // Duplicate for seamless loop
  const doubled = [...clients, ...clients, ...clients, ...clients];

  return (
    <section className="py-4 sm:py-4 overflow-hidden">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .marquee-track {
          animation: marquee 18s linear infinite;
          display: flex;
          width: max-content;
        }

        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">
        <h2 className="text-center text-2xl sm:text-3xl font-black text-black mb-5">
          Clients
        </h2>
      </div>

      {/* Full width marquee */}
      <div className="relative w-full">

        {/* Scrolling track */}
        <div className="marquee-track items-center gap-10 sm:gap-20 px-4">
          {doubled.map((client, i) => (
            <div
              key={`${client.name}-${i}`}
              className="flex-shrink-0 flex items-center justify-center opacity-50 hover:opacity-100 transition-opacity duration-300 px-2"
            >
              <img
                src={client.src}
                alt={client.name}
                className={`${client.height} w-auto object-contain grayscale brightness-55`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}